import { FIXED_INDENTS } from 'vars/index'

export const GeoblockErrorScreenDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type GeoblockErrorScreenDirection =
  (typeof GeoblockErrorScreenDirection)[keyof typeof GeoblockErrorScreenDirection]

export const GeoblockErrorScreenJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type GeoblockErrorScreenJustifyContent =
  (typeof GeoblockErrorScreenJustifyContent)[keyof typeof GeoblockErrorScreenJustifyContent]

export const GeoblockErrorScreenAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type GeoblockErrorScreenAlignItems =
  (typeof GeoblockErrorScreenAlignItems)[keyof typeof GeoblockErrorScreenAlignItems]

export const GeoblockErrorScreenPaddings = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_10: [FIXED_INDENTS.INDENT_350, FIXED_INDENTS.INDENT_300],
}

export type GeoblockErrorScreenPadding =
  (typeof GeoblockErrorScreenPaddings)[keyof typeof GeoblockErrorScreenPaddings]
